import ApiService from './api.service';

export type TenantUser = {
  id: string;
  name: string;
  email: string;
  profilePictureUrl?: string;
};

export type ListUsersResponse = {
  records: TenantUser[];
};

export class UserService {
  async listTenantUsers(): Promise<TenantUser[]> {
    const result = await ApiService.getInstance().request(
      'GET',
      '/tenant-config/users'
    ) as ListUsersResponse;

    return result.records;
  }
}

export const userService = new UserService();
